import React from 'react';
import {   Table, Icon, List, Popup } from 'semantic-ui-react';
import { Link } from "react-router-dom";


const PreguntasFrecuentesRow=({preguntasfrecuentes, onShowModalBorrar, onShowModalActivar, color,form, permisos})=>{
    return (
    <Table.Row>
                        <Table.Cell>{preguntasfrecuentes.descripcion}</Table.Cell>
                        <Table.Cell textAlign="center">{preguntasfrecuentes.estatus}</Table.Cell>
                        <Table.Cell textAlign="center">
                            <List horizontal>
                                <List.Item>
                                    <Link to={"/preguntasfrecuentes/"+preguntasfrecuentes.id}> 
                                     <Popup
                                        trigger={<Icon  name='edit outline' link   size="large"  color="tela" ></Icon>}
                                        content='Editar'
                                       
                                      />
                                     </Link> 
                                    
                                </List.Item>
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name='trash alternate outline' link 
                                            onClick={()=>onShowModalBorrar(preguntasfrecuentes.id)} 
                                            size="large" color="red"  />
                                        }
                                        content='Borrar'
                                      />
                                </List.Item>
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name={preguntasfrecuentes.idEstatus==1?'x':'check'} link  size="large" 
                                                color={preguntasfrecuentes.idEstatus==1?"orange":"green"}  
                                                onClick={()=>onShowModalActivar(preguntasfrecuentes.id)} 
                                            />
                                        }
                                        content={preguntasfrecuentes.idEstatus==1?'Inactivar':'Activar'}
                                      />  
                                    
                                </List.Item>
                            </List>
                    </Table.Cell>
                      
        </Table.Row>
    
    )
}


export default PreguntasFrecuentesRow;